// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.save-as-diet-template-page {
    padding: 30px;
    background-color: #A5D6A7;
    border-radius: 20px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    width: 800px;
    max-width: 90%;
    margin: 50px auto;
    font-family: 'Rubik', sans-serif;
  }
  
  .page-title1 {
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    color: #333;
    margin-bottom: 30px;
  }
  
  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  label {
    color: #333;
    font-size: 16px;
    font-weight: 600;
  }
  
  .small-input {
    padding: 10px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #ddd;
    background-color: #f9f9f9;
    width: 97%;
    margin-top: 8px;
  }
  
  .large-input {
    padding: 15px;
    font-size: 16px;
    border-radius: 10px;
    border: 1px solid #ddd;
    background-color: #f9f9f9;
    width: 96%;
    resize: vertical;
    margin-top: 8px;
    min-height: 300px;
  }
  
  .small-input:focus,
  .large-input:focus {
    border-color: #388E3C;
    outline: none;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);
  }
  
  .text-muted {
    font-size: 14px;
    color: #6c757d;
    margin-top: 5px;
  }
  
    .btn-save1 {
    background: #004D40;
    color: #fff;
    border: none;
    padding: 15px;
    border-radius: 15px;
    font-size: 18px;
    font-family: 'Rubik', sans-serif;
    cursor: pointer;
    font-weight: 600;
    width: 30%;
    margin: 0 auto;
    display: block;
    transition: all 0.3s ease;
  }
  
  .btn-cancel {
    background: #dc3545;
    color: white;
    border: none;
    padding: 15px;
    border-radius: 15px;
    font-size: 18px;
    font-family: 'Rubik', sans-serif;
    cursor: pointer;
    font-weight: 600;
    width: 30% !important;
    margin: 0 auto;
    margin-top: 20px;
    display: block;
    transition: all 0.3s ease;
  }
  
  .btn-save:hover {
    background: #2E7D32;
    transform: translateY(-2px);
  }
  
  .btn-cancel:hover {
    background: #c82333;
    transform: translateY(-2px);
  }
  
  .button-group {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
    width: 100%;
  }
  
  .btn-save1, .btn-cancel {
    flex: 1 1;
    max-width: 250px;
    min-width: 200px;
  }
  
  @media (max-width: 768px) {
    .button-group2 {
      flex-direction: column;
      align-items: center;
      gap: 15px;
    }
    
    .btn-save1, .btn-cancel {
      width: 100%;
      max-width: 100%;
    }
  }
  
  .success-message-container {
    position: fixed;
    top: 70px; 
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none; 
  }
  
.success-message18 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message18 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}
  
  @keyframes fadeInOut {
    0% { opacity: 0; transform: translateY(-20px); }
    10% { opacity: 1; transform: translateY(0); }
    90% { opacity: 1; transform: translateY(0); }
    100% { opacity: 0; transform: translateY(-20px); }
  }  `, "",{"version":3,"sources":["webpack://./src/styles/SaveAsDietTemplatePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;IACb,yBAAyB;IACzB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,cAAc;IACd,eAAe;EACjB;;IAEE;IACA,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;EACF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;;AAEF;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;EAEE;IACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;IAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;IAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACnD","sourcesContent":[".save-as-diet-template-page {\n    padding: 30px;\n    background-color: #A5D6A7;\n    border-radius: 20px;\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n    width: 800px;\n    max-width: 90%;\n    margin: 50px auto;\n    font-family: 'Rubik', sans-serif;\n  }\n  \n  .page-title1 {\n    text-align: center;\n    font-size: 28px;\n    font-weight: 700;\n    color: #333;\n    margin-bottom: 30px;\n  }\n  \n  form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  label {\n    color: #333;\n    font-size: 16px;\n    font-weight: 600;\n  }\n  \n  .small-input {\n    padding: 10px;\n    font-size: 16px;\n    border-radius: 10px;\n    border: 1px solid #ddd;\n    background-color: #f9f9f9;\n    width: 97%;\n    margin-top: 8px;\n  }\n  \n  .large-input {\n    padding: 15px;\n    font-size: 16px;\n    border-radius: 10px;\n    border: 1px solid #ddd;\n    background-color: #f9f9f9;\n    width: 96%;\n    resize: vertical;\n    margin-top: 8px;\n    min-height: 300px;\n  }\n  \n  .small-input:focus,\n  .large-input:focus {\n    border-color: #388E3C;\n    outline: none;\n    background-color: #ffffff;\n    box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);\n  }\n  \n  .text-muted {\n    font-size: 14px;\n    color: #6c757d;\n    margin-top: 5px;\n  }\n  \n    .btn-save1 {\n    background: #004D40;\n    color: #fff;\n    border: none;\n    padding: 15px;\n    border-radius: 15px;\n    font-size: 18px;\n    font-family: 'Rubik', sans-serif;\n    cursor: pointer;\n    font-weight: 600;\n    width: 30%;\n    margin: 0 auto;\n    display: block;\n    transition: all 0.3s ease;\n  }\n  \n  .btn-cancel {\n    background: #dc3545;\n    color: white;\n    border: none;\n    padding: 15px;\n    border-radius: 15px;\n    font-size: 18px;\n    font-family: 'Rubik', sans-serif;\n    cursor: pointer;\n    font-weight: 600;\n    width: 30% !important;\n    margin: 0 auto;\n    margin-top: 20px;\n    display: block;\n    transition: all 0.3s ease;\n  }\n  \n  .btn-save:hover {\n    background: #2E7D32;\n    transform: translateY(-2px);\n  }\n  \n  .btn-cancel:hover {\n    background: #c82333;\n    transform: translateY(-2px);\n  }\n  \n  .button-group {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 30px;\n    width: 100%;\n  }\n  \n  .btn-save1, .btn-cancel {\n    flex: 1;\n    max-width: 250px;\n    min-width: 200px;\n  }\n  \n  @media (max-width: 768px) {\n    .button-group2 {\n      flex-direction: column;\n      align-items: center;\n      gap: 15px;\n    }\n    \n    .btn-save1, .btn-cancel {\n      width: 100%;\n      max-width: 100%;\n    }\n  }\n  \n  .success-message-container {\n    position: fixed;\n    top: 70px; \n    left: 0;\n    right: 0;\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none; \n  }\n  \n.success-message18 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message18 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n  \n  @keyframes fadeInOut {\n    0% { opacity: 0; transform: translateY(-20px); }\n    10% { opacity: 1; transform: translateY(0); }\n    90% { opacity: 1; transform: translateY(0); }\n    100% { opacity: 0; transform: translateY(-20px); }\n  }  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
